module.exports = __webpack_public_path__ + "img/document-number.e5f1441c.svg";